import { request } from "utils/request";
import { delay, put, take, takeLatest, select } from "redux-saga/effects"
import { getDefaultHeaders } from "utils/helpers";
import { API_URL } from "utils/constants";
import { actions } from "./slice"
import { selectPendingForm } from "./selector"

export function* getFormsList(){
    yield delay(300)
    try{
        const options = {
            method: "GET",
            headers: getDefaultHeaders()
        }
    
    const response = yield request(`${API_URL}/form`,options)
    yield put(actions.FormsLisStucsses(response.data))

    }catch(error){
    yield put(actions.getFormsListFailer())

    }
}

export function* createForm(){
    yield delay(300)
    const form = yield select(selectPendingForm)
    try{
        const options = {
            method: "POST",
            headers: getDefaultHeaders(),
            body: JSON.stringify(form),
        }
    const response = yield request(`${API_URL}/form`, options)
    yield put(actions.craeteFormSucsses(response.data))

    }catch(error){
    yield put(actions.createFormFailer())
    }
}

export function* formSaga(){
    yield takeLatest(actions.getFormsList, getFormsList)
    yield takeLatest(actions.craeteForm, createForm)

}
